import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import {breakpointUp} from "../utils/breakpoints";

$(document).ready(function () {

  let scrollToTop = $('.js-scroll-to-top')

  if (breakpointUp('xl')){

    ScrollTrigger.create({
      onUpdate: self => {

        if (self.progress > 0.5) {
          scrollToTop.addClass('visible')
        } else {
          scrollToTop.removeClass('visible')
        }

      },
    });

  } else {

    ScrollTrigger.create({
      trigger: "footer",
      start: "top bottom",
      onEnter: self => scrollToTop.addClass('visible'),
      onLeaveBack: self => scrollToTop.removeClass('visible'),
    });

  }



  scrollToTop.click(function () {
    window.scrollTo(0, 0)
  })


})
